import { API_BASE_PATH } from "@/js/constants/index.js";

const apiRequest = async (path, method, body, withHeader = false) => {
  let options = {
    method,
    headers: {
      "Accept-Language": "en"
    }
  };

  if (body) {
    options = Object.assign({}, options, { body });
  }

  if (withHeader) {
    options = Object.assign({}, options, {
      headers: {
        ...options.headers,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
  }

  const res = await fetch(`${API_BASE_PATH}${path}`, options);
  const data = await res.json();

  return data;
};

export default apiRequest;
